import classnames from "classnames";
import { useTranslation , Trans } from "react-i18next";
import { BeatLoader } from "react-spinners";
import formatCurrency from "utils/formatCurrency";
import styles from "./styles.module.scss";
import Instruction from "components/base/Instruction";
import { useAppContext } from "context/AppContext";
import { renderLogo } from "utils/renderLogo";
import useGetSelectedPaymentMethodData from "hooks/utils/useGetSelectedPaymentMethodData";
import useUser from "hooks/useUser";

const SchoolModal = () => {
  const { t, i18n } = useTranslation();
  const appContext = useAppContext();
  const { data: paymentMethodData } = useGetSelectedPaymentMethodData();
  const instruction1 = t("yourOrder.instruction1");
  const confirmText = t("yourOrder.confirm");
  const instruction2 = (
  <Trans
    i18nKey="yourOrder.instruction2"
    values={{ brand: t("yourOrder.instruction3") }}
    components={{ 1: <span className={styles.Maviance} /> }}
  />
);
  const instruction3 = t("yourOrder.instruction3");
  const { user } = useUser();
  const finalQuote = user?.quote;

  const footerRows = [
    {
      title: t("yourOrder.subTotal"),
      value: formatCurrency(Number(appContext.amount) || 0)
    },
    {
      title: t("yourOrder.fees"),
      value: formatCurrency(finalQuote),
      highlight: true
    },
    {
      title: t("yourOrder.priceTotal"),
      value: formatCurrency(Number(appContext?.amount) + (finalQuote || 0) || 0)
    }
  ];

  return (
    <>
      {footerRows?.length > 0 && (
        <div className="mt-1">
          {footerRows?.map(({ title, value, highlight }, index) => (
            <div
              key={`${title}_${index}`}
              className={classnames(styles.footerRow, { [styles.footerRowHighlighted]: highlight })}
              data-testid="table-order-footer-row"
            >
              <span className={styles.orderTitle}>{title}</span>
              {finalQuote === null || finalQuote === undefined ? (
                <div className="d-flex align-items-center" data-testid="table-order-loader">
                  <BeatLoader color="#8d8d8d" />
                </div>
              ) : (
                <span>{value}</span>
              )}
            </div>
          ))}
        </div>
      )}

      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
          // padding: "20px"
        }}
      >
        <Instruction
          imgUrl={renderLogo(appContext?.paymentMethod)}
          containerClassName={styles.inlineContainer}
          htmlContent={paymentMethodData?.instructions?.find((l) => l.lang === i18n.language)?.text}
        >
          <div className={styles.instructionText} data-testid="loading-screen-title">
            <span className={styles.waitText}> {instruction1}&nbsp;</span>
            <span className={styles.confirm}> {confirmText},&nbsp; </span>
            <span className={styles.waitText}>{instruction2}&nbsp;</span>
            {i18n.language === "en" && (
              <span className={styles.Maviance}> {instruction3}</span>
            )}
          </div>
        </Instruction>
      </div>
    </>
  );
};

export default SchoolModal;
